<template>
  <div>
    <el-form
      ref="misFormRef"
      :model="misForm"
    >
      <div class="route_rule_title">{{ $t('newOrder.BasicInformation') }}</div><!-- 基础信息 -->
      <el-row
        type="flex" justify="left" :gutter="20"
        style="flex-wrap: wrap"
      >
        <!-- 规则名称 -->
        <el-col :span="8">
          <el-form-item
            :label="$t('collectionCenter.mis4')" prop="ruleName"
            :rules="{
              required: true,message: $t('collectionCenter.mis15'),trigger: ['blur', 'change']
            }"
          >
            <el-input
              v-model="misForm.ruleName" :placeholder="$t('collectionCenter.ruleNamePlaceholder')"
              type="textarea" :maxlength="100" show-word-limit
              rows="1" clearable size="medium"
              style="width: 100%" class="textarea_class"
              :disabled="misTitle === $t('collectionCenter.mis11')"
            />
          </el-form-item>
        </el-col>
        <!-- 始发转运中心 -->
        <el-col :span="8">
          <el-form-item
            :label="$t('collectionCenter.mis1')" prop="originHubId"
            :rules="{
              required: true,message: $t('GlobalSetObj.pleaseChoose'),trigger: ['blur', 'change']
            }"
          >
            <ElSelectV2
              v-model="misForm.originHubId"
              :options="siteList"
              :placeholder="$t('collectionCenter.originTransitCenterPlaceholder')"
              clearable filterable
              style="width: 100%" size="medium"
              popper-class="SelectV2_popper"
              :disabled="misTitle === $t('collectionCenter.mis11')"
              @change="ohChange"
            />
          </el-form-item>
        </el-col>
        <!-- 状态 -->
        <el-col :span="8">
          <el-form-item
            :label="$t('collectionCenter.stateZT')" prop="status"
            :rules="{
              required: true,message: $t('GlobalSetObj.pleaseChoose'),trigger: ['blur', 'change']
            }"
          >
            <el-select
              v-model="misForm.status"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable style="width: 100%" size="medium"
              :disabled="misTitle === $t('collectionCenter.mis11')"
            >
              <el-option :label="$t('GlobalSetObj.enable')" :value="1" />
              <el-option :label="$t('GlobalSetObj.stop')" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="route_rule_title">{{ $t('collectionCenter.mis12') }}</div><!-- 路径配置 -->
      <div class="route_configuration">
        <el-row
          type="flex" justify="left" style="gap: 10px"
        >
          <!-- ① 始发转运中心 -->
          <el-col :span="8" class="route_c_col_box">
            <div class="route_c_col">① {{ $t('collectionCenter.mis1') }}</div>
            <div class="route_c_bold">{{ originHubName || '- -' }}</div>
            <span class="route_c_grey">{{ $t('collectionCenter.mis16') }}</span>
          </el-col>
          <!-- ② 途径转运中心（可添加多个，按顺序展示） -->
          <el-col :span="8" class="route_c_col_box">
            <div class="route_c_col">② {{ $t('collectionCenter.mis17') }}</div>
            <div v-for="(item, idx) in transitCenterData" :key="idx" class="route_tc_box">
              <div class="route_tc_idx">{{ idx + 1 }}</div>
              <el-form-item
                :prop="'transitCenterData.' + idx"
                style="flex: 1; margin-bottom: 0;"
              >
                <ElSelectV2
                  v-model="misForm.transitCenterData[idx]"
                  :options="siteList"
                  :placeholder="$t('collectionCenter.originTransitCenterPlaceholder')"
                  clearable filterable
                  style="width: 100%" size="medium"
                  popper-class="SelectV2_popper"
                  :disabled="misTitle === $t('collectionCenter.mis11')"
                />
              </el-form-item>
              <el-button
                :style="{ visibility: transitCenterData.length > 1 && misTitle !== $t('collectionCenter.mis11') ? 'visible' : 'hidden' }"
                type="danger" plain size="small"
                @click="removeItem(idx)"
              >{{ $t('collectionCenter.Delete') }}</el-button>
            </div>
            <div v-if="misTitle !== $t('collectionCenter.mis11')" class="add_btn" @click="addItem">+ {{ $t('collectionCenter.mis18') }}</div><!-- 增加途径转运中心 -->
          </el-col>
          <!-- ③ 预派送网点 -->
          <el-col :span="8" class="route_c_col_box">
            <el-form-item
              prop="deliverySiteIds"
              :rules="{
                required: true,message: $t('collectionCenter.mis23'),trigger: ['blur', 'change']
              }"
            >
              <div class="route_c_col">③ {{ $t('GlobalSetObj.preEntrega') }}</div>
              <div
                v-if="misTitle === $t('collectionCenter.mis11') && cascaderList.length > 0"
                class="cascader_text_box"
              >
                <span v-for="(item, idx) in cascaderList" :key="idx">{{ item }}</span>
              </div>
              <el-cascader
                v-else
                v-model="misForm.deliverySiteIds"
                :options="siteData"
                :props="{
                  multiple: true,
                  value: 'value',
                  label: 'label'
                }"
                clearable filterable collapse-tags
                style="width: 100%;margin-top: 10px"
                @change="handleChange"
              />
            </el-form-item>
            <div class="cascader_msg">
              <span class="cascader_1">
                {{ $t('collectionCenter.mis19') }} {{ misForm.deliverySiteIds.length }} {{ $t('collectionCenter.mis20') }}
              </span>
              <!--   stateList遍历，展示为：州 该州网点个数 个    -->
              <span v-for="(item, idx) in stateList" :key="idx" class="cascader_2">
                {{ item.state }} {{ item.sum }} {{ $t('collectionCenter.mis21') }}
              </span>
            </div>
            <div class="cascader_3">{{ $t('collectionCenter.mis14') }}</div>
          </el-col>
        </el-row>
        <el-row>
          <!-- 路径预览 -->
          <el-col :span="24" class="route_box">
            <div class="route_preview">{{ $t('collectionCenter.mis22') }}：</div>
            <div v-if="routeData.origin || routeData.transits.length || routeData.deliveries.length">
              <!-- 第一部分：始发转运中心 -->
              <template v-if="routeData.origin">
                <span class="tag_route tag-first">{{ routeData.origin }}</span>
                <span v-if="routeData.transits.length || routeData.deliveries.length" class="arrow_separator">→</span>
              </template>

              <!-- 第二部分：途径转运中心 -->
              <template v-if="routeData.transits.length">
                <template v-for="(item, index) in routeData.transits">
                  <span :key="'transit-' + index" class="tag_route tag-middle">{{ item }}</span>
                  <!-- 途径转运中心内部箭头 -->
                  <span
                    v-if="index < routeData.transits.length - 1"
                    :key="'transit-arrow-' + index"
                    class="arrow_separator"
                  >→</span>
                </template>
                <span v-if="routeData.deliveries.length" class="arrow_separator">→</span>
              </template>

              <!-- 第三部分：预派送网点 -->
              <template v-if="routeData.deliveries.length">
                <template v-for="(item, index) in routeData.deliveries">
                  <span :key="'delivery-' + index" class="tag_route tag-last">{{ item }}</span>
                  <!-- 预派送网点内部箭头 -->
                  <span
                    v-if="index < routeData.deliveries.length - 1"
                    :key="'delivery-arrow-' + index"
                    class="arrow_separator"
                  >→</span>
                </template>
              </template>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div v-if="misTitle !== $t('collectionCenter.mis11')" style="text-align: right;margin: 20px 0">
      <el-button size="medium" class="default_btn" @click="closeThis">{{ $t('collectionCenter.cancel') }}</el-button><!-- 取消 -->
      <el-button
        type="primary" size="medium" class="blue_color_btn"
        @click="saveRule"
      >{{ $t('collectionCenter.mis13') }}</el-button><!-- 保存规则 -->
    </div>
  </div>
</template>

<script>
import ElSelectV2 from 'el-select-v2';
import { routeDeviationPathConfigAdd, routeDeviationPathConfigEdit } from '@/api/lanshou';

export default {
  components: {
    ElSelectV2
  },
  props: {
    misTitle: {
      type: String,
      default: ''
    },
    siteListVal: {
      type: Array,
      default: () => []
    },
    deliverySite: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      cascaderList: [],
      originHubName: '',
      misForm: {
        ruleName: '',
        originHubId: null,
        transitHubIds: [],
        deliverySiteIds: [],
        status: null,
        transitCenterData: []
      },
      siteList: [],
      routeData2: [],
      transitCenterData: [''],
      siteData: [],
      deliverySiteIdsList: [],
      stateList: []
    };
  },
  computed: {
    // eslint-disable-next-line vue/no-dupe-keys
    routeData() {
      /**
       * 后端提供了字段‘fullPath‘，可用于赋值到routeData
       * this.routeData = val.fullPath;
       * 但是需要处理返回值fullPath: "PERUS03 → SP-RR-001 → 测试安骏 → BAXIYOUZHENG"
       * 👆上述不方便做特殊样式处理
       */
      return this.setRouteData();
    }
  },
  methods: {
    assign(val) {
      this.$nextTick(() => {
        this.siteData = this.deliverySite;
        this.siteList = this.siteListVal;
        // 1. 基础信息回显
        if (val.id) {
          this.misForm.id = val.id;
        }
        this.misForm.ruleName = val.ruleName || '';

        // ①始发转运中心 - 过滤掉 siteList 中不存在的值
        const originHubId = val.originHubId || null;
        if (originHubId !== null) {
          const exists = this.siteList.some(item => item.value === originHubId);
          this.misForm.originHubId = exists ? originHubId : null;
        } else {
          this.misForm.originHubId = null;
        }

        this.misForm.status = val.status !== undefined && val.status !== null ? val.status : null;

        // ①始发转运中心赋值
        this.ohChange();
        // ②途径转运中心
        // transitCenterData[idx]
        // 3. 途径转运中心回显 - 过滤掉 siteList 中不存在的值
        if (val.transitHubIds && Array.isArray(val.transitHubIds) && val.transitHubIds.length > 0) {
          const validTransitIds = val.transitHubIds.filter(id =>
            this.siteList.some(item => item.value === id)
          );
          if (validTransitIds.length > 0) {
            this.transitCenterData = [...validTransitIds]; // 直接赋值过滤后的有效ID数组
            this.misForm.transitCenterData = [...validTransitIds];
          } else {
            this.transitCenterData = ['']; // 全部无效时，保留一个空项
            this.misForm.transitCenterData = [];
          }
        } else {
          this.transitCenterData = ['']; // 没有数据时，保留一个空项
          this.misForm.transitCenterData = [];
        }

        // ③ 预派送网点
        if (val.deliverySiteIds && Array.isArray(val.deliverySiteIds) && val.deliverySiteIds.length > 0) {
          this.deliverySiteIdsList = val.deliverySiteIds;
          // 需要将网点ID转换为级联选择器的路径值
          this.misForm.deliverySiteIds = this.convertSiteIdsToCascaderValue(val.deliverySiteIds);
          // 触发级联选择器的变化，更新路径预览和州统计
          this.handleChange(this.misForm.deliverySiteIds);

          if (this.misTitle === this.$t('collectionCenter.mis11')) {
            this.cascaderList = val.deliverySiteIds.map(id => {
              for (const parent of this.siteData) {
                const found = parent.children.find(child => child.value === id);
                if (found) return `${parent.label} / ${found.label}`;
              }
              return null;
            }).filter(Boolean);
          }
        } else {
          this.misForm.deliverySiteIds = [];
          this.deliverySiteIdsList = [];
          this.stateList = [];
          this.routeData2 = [];
        }
        // 路径预览
        this.setRouteData();
      });
    },
    convertSiteIdsToCascaderValue(siteIds) {
      if (!siteIds || !Array.isArray(siteIds) || siteIds.length === 0) {
        return [];
      }
      const result = [];
      for (const siteId of siteIds) {
        // 在 siteData 中查找该网点所属的父级
        for (const parent of this.siteData) {
          const found = parent.children.find(child => child.value === siteId);
          if (found) {
            result.push([parent.value, siteId]);
            break;
          }
        }
      }
      return result;
    },
    setRouteData() {
      // ”第一部分___获取始发转运中心名称“样式绑定'tag-first'；
      // ”第二部分___获取途径转运中心名称列表“样式绑定'tag-middle'；
      // ”第三部分___获取预派送网点名称列表“样式绑定'tag-last'
      return {
        origin: this.originHubName || '',
        transits: this.misForm.transitCenterData
          .map(id => this.siteList.find(item => item.value === id)?.label)
          .filter(Boolean),
        deliveries: this.routeData2 || []
      };
    },
    ohChange() {
      const originHub = this.siteList.find(item => item.value === this.misForm.originHubId);
      this.originHubName = originHub ? originHub.label : '';
    },
    clearForm() {
      this.misForm = {
        ruleName: '',
        originHubId: null,
        transitHubIds: [],
        deliverySiteIds: [],
        status: null,
        transitCenterData: []
      };
      this.transitCenterData = [''];
      this.$nextTick(() => {
        this.$refs.misFormRef.clearValidate();
      });
    },
    addItem() {
      this.transitCenterData.push('');
      this.misForm.transitCenterData.push('');
    },
    // 删除指定项
    removeItem(index) {
      this.transitCenterData.splice(index, 1);
      this.misForm.transitCenterData.splice(index, 1);
    },
    saveRule() {
      this.$refs['misFormRef'].validate((valid) => {
        if (valid) {
          const transitHubIds = this.misForm.transitCenterData.filter(item => item !== '');
          const status = this.misForm.status !== '' ? this.misForm.status : null;
          const form = JSON.parse(JSON.stringify(this.misForm));
          form.transitHubIds = transitHubIds;
          form.status = status;
          form.deliverySiteIds = this.deliverySiteIdsList;
          if (this.misTitle === this.$t('collectionCenter.mis9')) {
            // 新增
            routeDeviationPathConfigAdd(form).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully')); // 保存成功
                this.closeThis();
                this.$emit('to-search');
              }
            });
          }
          if (this.misTitle === this.$t('collectionCenter.mis10')) {
            // 编辑
            routeDeviationPathConfigEdit(form).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.closeThis();
                this.$emit('to-search');
              }
            });
          }
        }
      });
    },
    closeThis() {
      this.clearForm();
      this.$emit('mis-close');
    },
    handleChange(value) {
      // 过滤，只取网点id
      const leafValues = value.map(item => item[item.length - 1]);
      this.deliverySiteIdsList = leafValues;

      // 用来总结每个州下的网点
      const matchedChildren = leafValues
        .map(val => {
          for (const parent of this.siteData) {
            const found = parent.children.find(child => child.value === val);
            if (found) return found;
          }
          return null;
        })
        .filter(item => item !== null);
      this.stateList = matchedChildren.reduce((acc, curr) => {
        const existing = acc.find(item => item.state === curr.state);
        if (existing) {
          existing.sum += 1;
        } else {
          acc.push({ state: curr.state, sum: 1 });
        }
        return acc;
      }, []);

      // 路径预览，第三部分
      this.routeData2 = matchedChildren.map(item => item.label);
    }
  }
};
</script>

<style lang="scss" scoped>
.cascader_text_box {
  border: 1px solid #dcdfe6;border-radius: 5px;padding: 0 5px;box-sizing: border-box;
  span {
    background: #f0f2f5;color: #909399;font-size: 13px;line-height: 13px;border-radius: 5px;padding: 5px 6px;margin-right: 5px;
  }
}
.route_rule_title {
  font-size: 16px;
  font-weight: bold;
  color: #1f2937;
}
.route_configuration {
  margin-top: 10px;
  border: 1px solid #e6eaf2;background: #fcfcfd;border-radius: 13px;padding: 15px;box-sizing: border-box;
}
.route_c_col_box {
  padding: 10px;border: 1px solid #e6eaf2;background: #fff;border-radius: 10px;box-sizing: border-box;
}

.route_preview { font-size: 14px;font-weight: bold;color: #1f2937;margin-bottom: 10px; }
.route_box {
  border: 1px solid #d6f0ff;border-radius: 10px;background: #eef9ff;
  padding: 20px;box-sizing: border-box;
  margin-top: 10px;
}
.tag_route {
  flex-shrink: 0;padding: 3px 10px;border-radius: 16px;border: 1px solid;
  font-size: 13px;font-weight: bold;white-space: nowrap;margin: 5px 0;display: inline-block;box-sizing: border-box;
}
/* 第一个标签 - 橙色系 */
.tag-first { border-color: #ffd1a8;background-color: #fff3e7;color: #d65a16; }
/* 中间标签 - 绿色系 */
.tag-middle { border-color: #beeccd;background-color: #eafaf1;color: #19a65a; }
/* 最后一个标签 - 紫色系 */
.tag-last { border-color: #ddd0ff;background-color: #f3edff;color: #7c3aed; }
.arrow_separator { color: #bbb;font-weight: 300;flex-shrink: 0;margin: 0 2px; }

.default_btn { border-radius: 8px;padding: 10px 17px;box-sizing: border-box; }
.blue_color_btn { background: #2f63e6;border-color: #2f63e6;border-radius: 8px;padding: 10px 17px;box-sizing: border-box; }

.route_c_col {
  font-size: 14px;font-weight: bold;color: #536178;
}
.route_c_bold {
  font-size: 18px;font-weight: bold;color: #1f2937;margin: 10px 0;
}
.route_c_grey {
  font-size: 13px;color: #8a96a8;
}
.route_tc_box {
  display: flex;justify-content: space-between;align-items: center;margin: 10px 0;gap: 5px;
  .route_tc_idx {
    display: flex;justify-content: center;align-items: center;
    width: 25px;height: 25px;flex-shrink: 0;background: #dbf4ff;border-radius: 50%;
    color: #2781b8;font-size: 14px;font-weight: 700;
    min-width: 0;
  }
}
.add_btn {
  width: 100%;color: #2f63e6;background: #f5faff;font-size: 13px;font-weight: bold;cursor: default;
  border: 1px dashed #9ec5ff;border-radius: 8px;padding: 7px;
  box-sizing: border-box;
  display: flex;justify-content: center;align-items: center;
}

.cascader_msg {
  margin: 10px 0;display: flex;gap: 10px;flex-wrap: wrap;
}
.cascader_1, .cascader_2 {
  font-size: 13px;font-weight: bold;line-height: 13px;
  border: none;border-radius: 14px;padding: 7px 9px;box-sizing: border-box;
  white-space: nowrap;
}
.cascader_1 {
  color: #2f63e6;background: #eaf2ff;
}
.cascader_2 {
  color: #19a65a;background: #eafaf1;border: 1px solid #beeccd;
}
.cascader_3 {
  color: #b45309;background: #fff7ed;border: 1px solid #fed7aa;padding: 10px;border-radius: 9px;
  font-size: 13px;line-height: 15px;box-sizing: border-box;
}
.textarea_class ::v-deep .el-input__count {
  background: transparent;
  bottom: -9px;
  right: 18px;
}
.textarea_class ::v-deep textarea.el-textarea__inner {
  min-height: 36px !important;
  max-height: 200px !important;
}
</style>
